import { render, staticRenderFns } from "./POPSingle.vue?vue&type=template&id=c4acad80&scoped=true"
import script from "./POPSingle.vue?vue&type=script&lang=js"
export * from "./POPSingle.vue?vue&type=script&lang=js"
import style0 from "./POPSingle.vue?vue&type=style&index=0&id=c4acad80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4acad80",
  null
  
)

export default component.exports